export default __webpack_public_path__ + "static/media/account-small.b7c77319.svg";